import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M15.697 9.434a4.5 4.5 0 1 0 .217 4.788","key":"svg-1"}],["path",{"d":"M13.5 14h2.5v2.5","key":"svg-2"}]]

const IconBrandGrammarly = createReactComponent('outline', 'brand-grammarly', 'BrandGrammarly', __iconNode);

export default IconBrandGrammarly;